export default __webpack_public_path__ + "static/Dev-portal-meta-image-4f67abd9f8bc1bd0cb374da8411bffb5.png";